module.exports = __webpack_public_path__ + "static/media/manual_inventario_enerplan.b3fc192a.pdf";